import { container, title } from "../../../../assets/jss/material-kit-react.jsx"

const landingPageStyle = {
    container: {
        "font-family": "Open Sans",
        zIndex: "12",
        color: "#FFFFFF",
        maxWidth: "100%",
        padding: 0,
        ...container,
        // "@media (min-width: 1200px)": {
        //   maxWidth: "100%"
        // }
    },
    tryNowButton: {
        width: "30%",
        textTransform: "none",
        fontSize: "0.9rem",
        fontWeight: "700",
        padding: "0.7rem",
        fontFamily: "Open Sans",
        "&:hover,&:focus": {
            color: "#000",
            backgroundColor: "#ffe56b",
        },
    },
    title: {
        ...title,
        display: "inline-block",
        position: "relative",
        marginTop: "30px",
        minHeight: "32px",
        color: "#FFFFFF",
        textDecoration: "none",
        fontWeight: "100",
    },
    subtitle: {
        fontSize: "1.313rem",
        maxWidth: "500px",
        margin: "10px auto 0",
    },
    main: {
        background: "#FFFFFF",
        position: "relative",
        zIndex: "3",
    },
    mainRaised: {
        boxShadow:
            "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    },
}

export default landingPageStyle



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/landingPage.jsx